'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

///<reference path="../../../typings/tsd.d.ts" />
///<reference path="../../bindings/commons/API/Client/api.d.ts" />
///<reference path="../../bindings/address/API/Client/AddressModel.ts" />
///<reference path="address-service.ts" />
var address;
(function (address_1) {
    var controller;
    (function (controller) {
        var AddressConfig = function AddressConfig() {
            _classCallCheck(this, AddressConfig);

            this.cities = [];
            this.cepSearchError = false;
            this.loader = new common.Loader();
        };

        controller.AddressConfig = AddressConfig;

        var AddressController = function () {
            /*@ngInject*/

            function AddressController($scope, $state, $q, addressService) {
                _classCallCheck(this, AddressController);

                this.service = addressService;
                this.$q = $q;
            }

            _createClass(AddressController, [{
                key: 'getCities',
                value: function getCities(countryCode, stateCode) {
                    return this.service.getCity(this.address.countryCode, this.address.stateCode).then(function (cities) {
                        return cities;
                    });
                }
            }, {
                key: 'getCep',
                value: function getCep(zipCode) {
                    var _this = this;

                    var defer = this.$q.defer();
                    this.service.getCep(zipCode).then(function (address) {
                        if (address) {
                            _this.address = $.extend(_this.address, address);
                            _this.address.zipCode = zipCode;
                            defer.resolve(_this.address);
                        } else defer.reject(zipCode);
                    });
                    return defer.promise;
                }
            }]);

            return AddressController;
        }();

        controller.AddressController = AddressController;
    })(controller = address_1.controller || (address_1.controller = {}));
})(address || (address = {}));
angular.module('address').controller('addressController', address.controller.AddressController);